import { Stack } from '@mui/material';
import { ItemSeparatorItem } from 'common/ui/ItemSeparator';
import { RouterLink } from 'common/ui/RouterLink';
import { LocationOn, Phone } from '@mui/icons-material';
import { CandidateProfileDetails } from 'modules/candidate-profile/types/CandidateProfileDetails';

export const getCandidateProfileSeparatorItems = (
  candidateProfile: CandidateProfileDetails
): ItemSeparatorItem[] => {
  const items: ItemSeparatorItem[] = [];

  if (candidateProfile.company) {
    items.push(candidateProfile.company);
  }

  if (candidateProfile.originalSource) {
    items.push(candidateProfile.originalSource);
  }

  if (candidateProfile.location?.name) {
    items.push(
      <Stack direction="row" alignItems="center" gap={1}>
        <LocationOn fontSize="small" /> {candidateProfile.location.name}
      </Stack>
    );
  }

  if (candidateProfile.phoneNumber) {
    items.push(
      <RouterLink to={`tel:${candidateProfile.phoneNumber}`}>
        <Stack direction="row" alignItems="center" gap={1}>
          <Phone fontSize="small" />
          {candidateProfile.phoneNumber}
        </Stack>
      </RouterLink>
    );
  }

  if (candidateProfile.email) {
    items.push(
      <RouterLink to={`mailto:${candidateProfile.email}`}>
        {candidateProfile.email}
      </RouterLink>
    );
  }

  if (candidateProfile.atsCandidateId) {
    items.push(`ID ${candidateProfile.atsCandidateId}`);
  }

  return items;
};
